import { render, staticRenderFns } from "./mobile_delegation_manage.vue?vue&type=template&id=e80b1834&scoped=true&"
import script from "./mobile_delegation_manage.vue?vue&type=script&lang=js&"
export * from "./mobile_delegation_manage.vue?vue&type=script&lang=js&"
import style0 from "./mobile_delegation_manage.vue?vue&type=style&index=0&id=e80b1834&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80b1834",
  null
  
)

export default component.exports